var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "regime-cards" },
    _vm._l(_vm.cards, function(card) {
      return _c(
        "div",
        {
          key: card.key,
          staticClass: "regime-cards__card az-card-bordered",
          class: { "regime-cards__card--highlight": card.highlight }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "regime-cards__head d-flex align-center justify-space-between mb-2"
            },
            [
              _c(
                "div",
                { staticClass: "d-flex align-center az-gap-xxsmall" },
                [
                  _c(
                    "span",
                    { staticClass: "az-text-primary az-size-14 font-semibold" },
                    [_vm._v(_vm._s(card.nome))]
                  ),
                  _c(
                    "v-tooltip",
                    {
                      attrs: { right: "", "max-width": "280" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "activator",
                            fn: function(ref) {
                              var on = ref.on
                              var attrs = ref.attrs
                              return [
                                _c(
                                  "span",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "regime-cards__info d-inline-flex"
                                      },
                                      "span",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("icon-svg", {
                                      attrs: {
                                        name: "info-circle",
                                        size: "14",
                                        color: "secondary"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c("div", [
                        _c("div", [_vm._v(_vm._s(card.subtitulo))]),
                        _c("div", { staticClass: "mt-1" }, [
                          _vm._v(_vm._s(card.trInvLabel))
                        ])
                      ])
                    ]
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "d-flex align-center az-gap-xsmall" },
                [
                  _vm.usarChipFixoDeRegime
                    ? [
                        card.chipContent
                          ? _c("BaseStatus", {
                              attrs: {
                                soft: "",
                                content: card.chipContent,
                                color: card.chipColor,
                                "preserve-case": ""
                              }
                            })
                          : _vm._e()
                      ]
                    : [
                        card.cheapest
                          ? _c("BaseStatus", {
                              attrs: {
                                soft: "",
                                content: "mais barato",
                                color: _vm.badgeColors.cheap,
                                "preserve-case": ""
                              }
                            })
                          : _vm._e(),
                        card.topAdv
                          ? _c("BaseStatus", {
                              attrs: {
                                soft: "",
                                content: "+ receita líq.",
                                color: _vm.badgeColors.adv,
                                "preserve-case": ""
                              }
                            })
                          : _vm._e()
                      ]
                ],
                2
              )
            ]
          ),
          _c(
            "div",
            { staticClass: "d-flex align-center az-gap-xxsmall" },
            [
              _c(
                "span",
                { staticClass: "regime-cards__section-label az-text-small" },
                [_vm._v("Custo do cliente")]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "", "max-width": "280" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "span",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "regime-cards__info d-inline-flex",
                                    attrs: { "data-test": "info-custo" }
                                  },
                                  "span",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "info-circle",
                                    size: "12",
                                    color: "secondary"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_c("div", [_vm._v(_vm._s(card.decomposicao))])]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "regime-cards__cost d-flex align-baseline az-gap-small"
            },
            [
              _c(
                "span",
                { staticClass: "az-title-secondary regime-cards__cost-value" },
                [_vm._v(_vm._s(card.custoPct))]
              ),
              _c("span", { staticClass: "az-text-small" }, [
                _vm._v(_vm._s(card.custoAno))
              ])
            ]
          ),
          _c("v-divider", { staticClass: "my-4" }),
          _c(
            "div",
            { staticClass: "d-flex align-center az-gap-xxsmall" },
            [
              _c(
                "span",
                {
                  staticClass: "regime-cards__section-label az-text-small",
                  attrs: { "data-test": "rotulo-receita" }
                },
                [_vm._v(_vm._s(_vm.rotuloReceita))]
              ),
              _c(
                "v-tooltip",
                {
                  attrs: { right: "", "max-width": "280" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function(ref) {
                          var on = ref.on
                          var attrs = ref.attrs
                          return [
                            _c(
                              "span",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass:
                                      "regime-cards__info d-inline-flex",
                                    attrs: { "data-test": "info-receita" }
                                  },
                                  "span",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("icon-svg", {
                                  attrs: {
                                    name: "info-circle",
                                    size: "12",
                                    color: "secondary"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        }
                      }
                    ],
                    null,
                    true
                  )
                },
                [_c("div", [_vm._v(_vm._s(card.receitaRacional))])]
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass:
                "regime-cards__cost d-flex align-baseline az-gap-small"
            },
            [
              _c(
                "span",
                { staticClass: "az-title-secondary regime-cards__cost-value" },
                [_vm._v(" " + _vm._s(card.advPct) + " ")]
              ),
              _c("span", { staticClass: "az-text-small" }, [
                _vm._v(_vm._s(card.advAno))
              ])
            ]
          )
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }